<template>
	<b-row>
		<b-col cols="12">
			<b-card>
				<div slot="header">
					{{this.$t('sidebar.warehouse-management.sector')}}
					<div class="card-header-actions">
						<b-link
							@click="addNewSector(null, 'create')"
							class="card-header-action btn-setting"
							style="font-size: 15px"
						>
							<i class="fa fa-plus-circle"></i>
						</b-link>

					</div>
				</div>
				<b-table class="generalTableClass" hover="hover" striped="striped"
						 :items="sectors" :fields="computedFields" show-empty>

					<!-- EMPTY SLOT FOR TABLE -->
					<template slot="empty" slot-scope="scope">
						<h4>{{ $t('empty') }}</h4>
					</template>
					<!-- EMPTY SLOT FOR TABLE -->

					<template slot="id" slot-scope="data">
						<strong>{{ data.index + 1 }}</strong>
					</template>
					<template slot="actions" slot-scope="data">


						<b-link :key="data.item.id + 'delete'"
								@click="closeOthers(data.item.id)"
								:id="'popOverDelete'+data.item.id"
						>
							<i class="fa fa-trash"></i>
						</b-link>

						<div>
							<b-popover
								:key="data.item.id + 'popover'"
								:target="'popOverDelete'+data.item.id"
								placement="bottom"
								:ref="'popover' + data.item.id"
								class="refDeleteConfirm"
							>
								<template slot="title">
									<b-button @click="deletePopover(data.item.id)" class="close"
											  aria-label="Close" style="margin-left: 5px">
										<span class="d-inline-block" aria-hidden="true">&times;</span>
									</b-button>
									{{ $t('want_to_delete?') }}
								</template>

								<div>
									<!--<b-link @click="onClose" size="sm" variant="danger">Yo'q</b-link>
                                    <b-link @click="onOk" size="sm" variant="primary">Ha</b-link>-->
									<div class="row mt-1">
										<div class="col-6">
											<b-button variant="outline-danger" size="sm" block
													  @click="deletePopover(data.item.id)"
											> {{ $t('words.no')
												}}
											</b-button>
										</div>
										<div class="col-6">
											<b-button variant="outline-success" size="sm" block
													  @click="remove(data.item.id)">{{ $t('words.yes')
												}}
											</b-button>
										</div>
									</div>
								</div>
							</b-popover>

						</div>

						<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

						<b-link @click="addNewSector(data.item)" v-b-tooltip.hover
						>
							<i class="fa fa-edit"></i>
						</b-link>
						<b-link @click="controlSector(data.item)" v-b-tooltip.hover
						>
							<i class="fa fa-exchange"></i>
						</b-link>


					</template>
				</b-table>
				<nav>
					<b-pagination :total-rows="totalCount" :per-page="searchForm.limit" v-model="searchForm.page"
								  :prev-text="$t('pagination.prev')"
								  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
				</nav>


				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
							class="create-modal" spacer v-model="addSector">
					<b-container index="1" v-if="addSector">
						<new-sector @success="reloadList()"
									@close="close"
									@save="saveOrUpdate"
									:mode="mode"
									:item="item"
						></new-sector>
					</b-container>
				</vs-sidebar>


				<vs-sidebar :click-not-close="true" position-right parent="body" default-index="1" color="primary"
							class="create-modal" spacer v-model="controlSectorModal">
					<b-container index="1" v-if="controlSectorModal">
						<control-sector @success="reloadList()"
									@close="closeSectorControl"
									@save="saveSectorControl"
									:item="currentSector"
						></control-sector>
					</b-container>
				</vs-sidebar>


			</b-card>
		</b-col>
	</b-row>

</template>

<script>
	import {mapGetters, mapActions} from 'vuex'
	import Multiselect from 'vue-multiselect'
	import WhDocument from "../../../services/wh-document.service";
	import NewSector from './newSector'
	import ControlSector from './controlSector'


	export default {
		name: 'Sector',
		data() {
			return {
				totalCount: 0,
				sectors: [],
				addSector: false,
				controlSectorModal:false,
				mode: 'create',
				item: {
					name: '',
					departmentId: null,
					comment: ''
				},
				currentSector:[],
				searchForm: {
					page: 1,
					limit: 20
				},
				computedFields: [
					{
						key: 'id',
						label: 'ID',
						visible: true,
						changebale: false
					},
					{
						key: 'name',
						label: this.$t('section.create.name'),
						visible: true,
						changebale: false
					},
					{
						key: 'departmentName',
						label: this.$t('incomes.department'),
						visible: true,
						changebale: false
					},
					{
						key: 'comment',
						label: this.$t('client.create.comment'),
						visible: true,
						changebale: false
					},
					{
						key: 'actions',
						label: this.$t('goods.actions'),
						'class': 'table_actions',
						visible: true,
						changebale: false
					}
				]

			}
		},
		methods: {
			addNewSector(item = null, mode = 'create') {
				if (item !== null) {
					this.item = item
				} else {
					this.item = {
						name: '',
						departmentId: null,
						comment: ''
					}
				}
				this.addSector = true;
			},
			close() {
				this.addSector = false;
			},
			closeSectorControl() {
				this.controlSectorModal = false;
			},
			controlSector(item){
				this.currentSector = item;
				this.controlSectorModal = true;
			},
			async reloadList() {
				await WhDocument.getSectorsList(this.searchForm).then(response => {
					this.sectors = response.items
					this.totalCount = response.total
				});
			},
			deletePopover(index) {
				const refName = `popover${index}`;
				this.$refs[refName].$emit('close')
			},
			closeOthers(id) {
				Object.keys(this.$refs).map(key => {
					if (key !== `popover${id}`) {
						const refName = `popover${id}`;
						this.$refs[refName].$emit('close')
					}
				});
			},
			async remove(id) {
				await WhDocument.deleteSector(id).then(() => {
					this.reloadList();
				});
			},
			saveSectorControl(data){
				this.controlSectorModal = false;
				WhDocument.changeSectors(data).then(response => {
					if (response.status) {
						this.$vs.notify({
							text: "Success",
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
					} else {
						this.$vs.notify({
							text: "Error",
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});

					}
					this.reloadList();
				});
			},

			saveOrUpdate(data) {
				this.addSector = false;
				let searchForm = data;
				searchForm.departmentId = data.departmentId.id;
				searchForm.page = this.page;
				searchForm.limit = this.limit;
				let mode = null;
				if(data.id){
					mode = 'update'
				}
				WhDocument.createOrUpdateSector(searchForm,mode).then(response => {
					if (response.status) {
						this.$vs.notify({
							text: "Success",
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
					} else {
						this.$vs.notify({
							text: "Error",
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});

					}
					this.reloadList();
				});
			}

		},
		async created() {
			this.reloadList(this.searchForm)

		},
		watch: {
			'searchForm.page': {
				handler(newValue, oldValue) {
					this.reloadList();
				}
			},
		},
		computed: {},
		components: {
			Multiselect,
			NewSector,
			ControlSector
		},
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
